import { React, useState } from 'react'
import Header from '../../components/headers/Header'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentClubCuidatia } from '../../components/clubCuidatia/ContentClubCuidatia'
import { ContentClubCuidatiaV2 } from '../../components/clubCuidatiaV2/ContentClubCuidatiaV2'
import './ClubCuidatia.css'
import { animateScroll as scroll } from 'react-scroll';
import HeaderHome from '../../components/headerHome/HeaderHome'
import { Helmet } from 'react-helmet'
import { MenuLateralAB } from '../../components/menuLateralAA/MenuLateralAB'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export const ClubCuidatia = () => {

const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
const [autLocalidades, setAutLocalidades] = useState(false);
const [OverleyModal, setOverleyModal] = useState("true");

const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }

  }
// El estado MenuLateralAux indica si el menú lateral está abierto o cerrado.
const [MenuLateralAux, setMenuLateralAux] = useState();

/**
 * Cambia el estado MenuLateralAux para abrir o cerrar el menú lateral.
 */
const chageMenuLateralAux = () => {
setMenuLateralAux(!MenuLateralAux)
};

    return (
        <div>
            <Helmet>
                <title>Club Cuidatia</title>
                <meta name="description" content="Bienvenido al Club Cuidatia, donde la salud y el bienestar son nuestra prioridad. Explora nuestros servicios y únete a nuestra comunidad." />
                <link rel="canonical" href="https://www.cuidatia.org/club-cuidatia" />
            </Helmet>
            <div className='headerPagina' >
                <MenuLateralAB  seleccionado={15} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
                <div onClick={closeMenu} Id="Market">
                    <div className="headerPagina"  >
                        <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}
                        />
                    </div>
                </div>
            </div>
            <div className='club-cuidatia-body'>
                <ContentClubCuidatiaV2 />
                <ContentClubCuidatia />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}